import { useCallback } from 'react'

export const useOpenMeetingPrepFromHost = () => (
  useCallback(async (contact, meeting) => {
    try {
      const mod = await import(
        'oap_web/HostMeetingPrep'
      )

      mod.openMeetingPrepFromHost?.(contact, meeting)
    } catch {
      // Remote missing
    }
  }, [])
)
